/**
 * Срыв ленивой загрузки экрана.
 *
 * После выката новой версии старые файлы с сервера исчезают, а вкладка,
 * открытая до выката, продолжает их запрашивать: переход в раздел падает с
 * ошибкой загрузки модуля. Это не поломка приложения, а устаревшая вкладка, и
 * говорить об этом человеку надо иначе — «обновите страницу», а не «сбой».
 *
 * Формулировки у браузеров разные, поэтому проверяется набор признаков.
 */

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? `${error.name} ${error.message}` : String(error);

  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('ChunkLoadError')
  );
}
